import {lazy} from 'react'
import {RouteObject} from 'react-router-dom'
import {AppHelmet} from '../../components/utils/AppHelmet'
import {AppLayout} from '../../components/utils/AppLayout'
import {PageSuspenseFallback} from '../../components/utils/PageSuspenseFallback'
// import {SUPER_ADMIN_EMAIL_REGEX} from '../../config/env'
import {AuthProtectedLayout} from '../auth/components/AuthProtectedLayout'

const CategoryPage = lazy(() => import('./pages/CategoryPage'))
const CategoryCreatePage = lazy(() => import('./pages/CategoryCreatePage'))
const CategoryEditPage = lazy(() => import('./pages/CategoryEditPage'))

export const CATEGORY_ROUTES: RouteObject[] = [
  {
    path: '/categories',
    element: (
      <>
        <AppHelmet title='Categories' />
        <AuthProtectedLayout adminOnly>
          <AppLayout>
            <PageSuspenseFallback>
              <CategoryPage />
            </PageSuspenseFallback>
          </AppLayout>
        </AuthProtectedLayout>
      </>
    ),
    children: [
      {
        path: '/categories/create',
        element: (
          <>
            <AppHelmet title='Category create' />
            <PageSuspenseFallback>
              <CategoryCreatePage />
            </PageSuspenseFallback>
          </>
        ),
      },
      {
        path: '/categories/:categoryCode/edit',
        element: (
          <>
            <AppHelmet title='Category edit' />
            <PageSuspenseFallback>
              <CategoryEditPage />
            </PageSuspenseFallback>
          </>
        ),
      },
    ],
  },
]
